import { offlineIngestMessage } from "../../state/actions/chats";
import store from "../../state/configureStore";


export const processMessageQueue = ({ messageQueue }) => {
    if (messageQueue.current.length === 0) return;
    const selectedConversation = store.getState().chats?.selectedConversation
    const { conversationId = null } = selectedConversation || {}

    messageQueue?.current?.forEach(({ messageObj }) => {
        const { details } = messageObj;
        const message = details?.[0];

        if (!message) return;

        const updatedMessageObj = {
            addedByBot: message?.addedByBot ?? true,
            userId: messageObj.userId,
            conversation: messageObj.conversation,
            bot: messageObj.bot,
            createdOn: messageObj.createdOn,
            createdBy: messageObj.createdBy,
            contentType: messageObj.contentType,
            messageType: message.messageType ?? messageObj.contentType,
            messageId: message.messageId,
            uuid: message.uuid,
            messageDate: message.messageDate,
            botKey: message.botKey,
            status: message.status,
            message: message.msg || message.message,
            options: message.options ? message.options : message.msg?.options,
        };

        //store and handle message locally with tabStack (within redux)
        store.dispatch(offlineIngestMessage(updatedMessageObj, updatedMessageObj.conversation || conversationId));
    });

    messageQueue.current = [];
};